import { render, staticRenderFns } from "./type-clause.vue?vue&type=template&id=72d5f8bd&"
import script from "./type-clause.vue?vue&type=script&lang=js&"
export * from "./type-clause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports